<template>
  <div class="select-user-organization">
    <SelectStore />
  </div>
</template>

<script>
// @ is an alias to /src
import SelectStore from "@/components/SelectStore.vue";

export default {
  name: "selectStore",
  components: {
    SelectStore,
  },
};
</script>
<style lang="scss"></style>
